import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// 環境別のFirebase設定
const firebaseConfigs = {
  production: {
    apiKey: "AIzaSyCQO-qAXyl820XNSiVUDbbCC8KKnp3WRmw",
    authDomain: "art-flea-9c326.firebaseapp.com",
    projectId: "art-flea-9c326",
    storageBucket: "art-flea-9c326.appspot.com",
    messagingSenderId: "1051584390020",
    appId: "1:1051584390020:web:your-web-app-id"
  },
  test: {
    apiKey: "AIzaSyDfXqiULV5TeO98V46jPNKZ2R8o8rgPoNA",
    authDomain: "art-flea-test.firebaseapp.com",
    projectId: "art-flea-test",
    storageBucket: "art-flea-test.firebasestorage.app",
    messagingSenderId: "122338560293",
    appId: "1:122338560293:web:ce453ee5e7d6da17b432cc",
    measurementId: "G-M6P5PN5YNS"
  }
};

// 環境変数から環境を判定（デフォルトはtest）
const environment = process.env.REACT_APP_FIREBASE_ENV || 'test';

console.log(`🔧 Firebase環境: ${environment}`);

// Firebase設定を選択
const firebaseConfig = firebaseConfigs[environment as keyof typeof firebaseConfigs];

if (!firebaseConfig) {
  throw new Error(`Invalid Firebase environment: ${environment}`);
}

console.log(`📡 接続先プロジェクト: ${firebaseConfig.projectId}`);

// Firebase アプリの初期化
const app = initializeApp(firebaseConfig);

// Firebase サービスの初期化
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

export default app;